import { Modal } from '@favordelivery/tupperware'
import OutOfZoneIcon from '../icons/OutOfZone'
import { Button } from './Input'
import styled from 'styled-components'
import { t } from '@utils/lang'

const ModalSC = styled(Modal)`
  text-align: center;
  color: var(--themeColorForegroundSecondary);
  font-size: ${p => p.theme.font.size.body};
  max-width: calc(100% - 32px);

  .title {
    color: var(--themeColorForegroundPrimary);
    font-weight: ${p => p.theme.font.weight.bold};
    font-size: ${p => p.theme.font.size.h4};
  }

  p {
    margin: 8px 0 14px;
  }
`

const OutOfAreaModal = ({ show, onClose }) => (
  <ModalSC show={show} zIndex={10} onDismiss={onClose}>
    <OutOfZoneIcon />
    <div className="title">{t('outOfAreaTitle_s')}</div>
    <p>{t('outOfAreaBody_s')}</p>
    <Button onClick={onClose}>{t('outOfAreaOk_s')}</Button>
  </ModalSC>
)

export default OutOfAreaModal
